// Valeurs par défaut des filtres de la liste des clients — source unique.
// Module pur (aucun import) : importable depuis les helpers de la cartouche
// et depuis jest sans tirer axios / jotai. Sert aussi de « valeur vide » de
// chaque champ (désactivation d'une vue rapide, retrait d'un jeton).
// `statutContrat: 10` = contrats en cours (POLICIES_STATUS), défaut historique.
export const CLIENT_USER_FILTERS_DEFAULT = Object.freeze({
  email: "",
  nomPrenomClient: "",
  nomSociete: "",
  sirenOuSiret: "",
  numeroContrat: "",
  statutContrat: 10,
  statutCompte: "",
  compagniesAssurances: Object.freeze([]),
  typesProduits: Object.freeze([]),
  produits: Object.freeze([]),
  partenaire: "",
  auMoins1Contrat: false,
  typeClient: "",
  avecEcheancierOuMensualisation: false,
});

export const CLIENT_FILTERS_DEFAULT = Object.freeze({
  user: CLIENT_USER_FILTERS_DEFAULT,
  page: 1,
});

// Copie modifiable des défauts (l'atom et les réinitialisations).
export const filtresClientsParDefaut = () => ({
  user: { ...CLIENT_USER_FILTERS_DEFAULT },
  page: 1,
});
